var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8215 5.21753C13.8215 7.8805 11.6632 10.0391 9 10.0391C6.33682 10.0391 4.17847 7.88071 4.17847 5.21753C4.17847 2.55435 6.33682 0.395996 9 0.395996C11.6632 0.395996 13.8215 2.55435 13.8215 5.21753Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7857 11.9673H3.21429C1.44642 11.9673 0 13.4137 0 15.1816C0 16.9494 1.44642 18.3959 3.21429 18.3959H14.7857C16.5536 18.3959 18 16.9494 18 15.1816C18 13.4137 16.5536 11.9673 14.7857 11.9673Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.36bdd34ff971159745d8ac3edafa45c6.svg";
export { ForwardRef as ReactComponent };